<ng-container *transloco="let t">
@for (task of tasks; track task.taskId) {
  <div class="d-flex align-items-stretch">
    <div class="card w-100 mb-4 border border-2 mobile-task-card" [class.mobile-expanded]="isTaskExpanded(task.taskId)">

      <!-- Mobile: compact accordion summary row (hidden on desktop) -->
      <div class="mobile-task-summary d-none" (click)="toggleTaskExpanded(task.taskId)">
        <div class="mobile-task-summary-left">
          <div class="mobile-task-title">{{ (task | taskText:'docType') || (task | taskText:'description') }}</div>
          <div class="mobile-task-meta">
            @if(task.borrowerId){
              <span class="mobile-borrower-name">{{ task?.borrowerName || t('portal.tasks.unknown') }}</span>
              <span class="mobile-meta-dot">&middot;</span>
            }
            @if(!isSubmitted){
              @if (task?.dueDate | dueDate; as due) {
                <span [class.mobile-overdue]="due.overdue">{{ due.overdue ? t('portal.tasks.overdue') + ' · ' : t('portal.tasks.due') + ' ' }}{{ due.date }}</span>
              }
            }
          </div>
        </div>
        <div class="mobile-task-summary-right">
          @if(task.borrowerTaskStatus === 'Submitted'){
            <span class="badge rounded-pill bg-light text-dark mobile-status-badge">{{ t('portal.tasks.submitted') }}</span>
          }
          @if(task.borrowerTaskStatus === 'Rejected'){
            <span class="badge rounded-pill bg-warning text-dark mobile-status-badge">{{ t('portal.tasks.rejected') }}</span>
          }
          @if(task.borrowerTaskStatus === 'Completed'){
            <span class="badge rounded-pill bg-light text-dark mobile-status-badge">{{ t('portal.tasks.completed') }}</span>
          }
          <i class="fas fa-chevron-down mobile-chevron" [class.rotated]="isTaskExpanded(task.taskId)"></i>
        </div>
      </div>

      <!-- Mobile: expandable action area (hidden until expanded) -->
      <div class="mobile-expand-content">
        <!-- Task description & due date details -->
        <div class="mobile-detail-section">
          @if (task | taskText:'distinctDescription'; as description) {
            <div class="mobile-detail-row">
              <span class="mobile-detail-label">{{ t('portal.tasks.description') }}</span>
              <span class="mobile-detail-value">{{ description }}</span>
            </div>
          }
          @if (isSubmitted) {
            <div class="mobile-detail-row">
              <span class="mobile-detail-label">{{ task?.borrowerTaskStatus }}:</span>
              <span class="mobile-detail-value">{{ (task?.approvedDate || task?.submittedDate) | date:'MMM d, y, h:mm a' }}</span>
            </div>
          }
        </div>

        <div class="mobile-actions-row">
          @if (showAssetsButton && task.borrowerTaskStatus !== 'Completed') {
            <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color" (click)="openAssetsModal(task)">
              {{ t('portal.tasks.startAssetVerification') }}
            </a>
          }
        </div>
        @if (task.borrowerFacingNote) {
          <div class="mobile-note-section">
            <small class="text-muted d-block mb-1">{{ t('portal.tasks.loanTeamMessage') }}</small>
            <p [innerHTML]="(task | taskText:'borrowerFacingNote') | htmlText" class="mb-0"></p>
          </div>
        }
      </div>

      <!-- Desktop: full card layout (hidden on mobile via CSS) -->
      <div class="desktop-task-content">
        <div class="card-header px-4 d-flex align-items-center justify-content-between border-bottom-2">
          <h4 class="mb-0">
            {{ (task | taskText:'docType') || (task | taskText:'description') }}
            @if (task | taskText:'distinctDescription'; as description) {
              <br>
              <span class="text-gray-700 fs-8 fw-bold">{{ description }}</span>
            }
          </h4>
        </div>

        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
              @if (task.borrowerId) {
                <div class="d-flex align-items-center">
                  <span
                    class="bp-contact-name-circle p-2 rounded-circle fw-bold d-flex align-items-center justify-content-center">
                    {{ task.borrowerName?.charAt(0) }}
                  </span>
                </div>
              }
              <div class="d-flex flex-column ms-2">
                <strong>{{ task?.borrowerName || t('portal.tasks.unknown') }}</strong>
                @if (!isSubmitted) {
                  @if (task?.dueDate | dueDate; as due) {
                    <span class="text-nowrap" [class.text-danger]="due.overdue">{{ due.overdue ? t('portal.tasks.overdue') + ' · ' : t('portal.tasks.due') + ' ' }}{{ due.date }}</span>
                  }
                }
                @if (isSubmitted) {
                  <span class="text-nowrap">{{ (task?.submittedDate || task?.approvedDate) | date:'MM/dd/yy, h:mm a' }}</span>
                }
              </div>
            </div>
            <div>
              @if (task.borrowerFacingNote && task.borrowerTaskStatus === 'Rejected') {
                <span class="badge rounded-pill bg-warning text-dark task-status-badge">{{ t('portal.tasks.urgentMessage') }}</span>
              }
              @if (task.borrowerFacingNote && task.borrowerTaskStatus !== 'Rejected') {
                <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ t('portal.tasks.newMessage') }}</span>
              }
              @if (task.linkedDocuments && task.linkedDocuments.length) {
                <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ task.linkedDocuments.length }}
                  {{ t('portal.tasks.documents') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Pending') {
                <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ t('portal.tasks.pending') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Submitted') {
                <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ t('portal.tasks.submitted') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Rejected') {
                <span class="badge rounded-pill bg-warning text-dark task-status-badge">{{ t('portal.tasks.rejected') }}</span>
              }
              @if (task.borrowerTaskStatus === 'Completed') {
                <span class="badge rounded-pill bg-light text-dark task-status-badge">{{ t('portal.tasks.completed') }}</span>
              }
            </div>
          </div>

          @if (showAssetsButton) {
            <div class="row my-2">
              @if (task.borrowerTaskStatus !== 'Completed') {
                <div class="w-100 d-flex justify-content-center p-3">
                  <a href="javascript:void(0)" class="btn btn-sm bp-primary-bg-color" (click)="openAssetsModal(task)">{{ t('portal.tasks.startAssetVerification') }}
                  </a>
                </div>
              }
            </div>
          }
        </div>
      </div>

    </div>
  </div>
}
</ng-container>
